//重量的数量转换
export function weightUnitChange(num) {
    num = num * 1;
    if (num >= 1000) {
        num = num / 1000 + "";
        let index = num.indexOf(".");
        if (index != -1) {
            num = num.slice(0, num.indexOf(".") + 3);
        }
        num = num * 1;
    }
    return num;
}
//重量的单位转换
export function weightUnit(num) {
    if (num >= 1000) {
        return "吨";
    }
    return "公斤";
}
//钱的数量转换
export function moneyUnit(money) {
    if (money < 10000) {
        return "元";
    } else if (money >= 10000 && money < 100000000) {
        return "万元";
    } else if (money >= 100000000) {
        return "亿元";
    }
}
//钱的单位转换
export function unitChange(money) {
    money = (money * 1).toFixed(2);
    if (money >= 10000 && money < 100000000) {
        money = money / 10000 + "";
        if (money.indexOf(".") != -1) {
            money = money.slice(0, money.indexOf(".") + 3);
        }
    } else if (money >= 100000000) {
        money = money / 100000000 + "";
        if (money.indexOf(".") != -1) {
            money = money.slice(0, money.indexOf(".") + 3);
        }
    }
    return money;
}